import React, { useState } from 'react'
import _ from 'lodash'
import { Link } from 'react-router-dom'
import {
  message, Select, Icon, Menu, Dropdown, Button, Select as AntdSelect, Modal, Radio, Upload, Input,
} from 'antd'
import {
  SmallText, Div, Button as KonsysButton, InputWithLabel,
} from 'konsys-ui'
import { useMutation, useQuery } from '@apollo/react-hooks'
import { TIRE_PATCH_LIST } from '../../constants/graph/query'
import { APPROVE_TIRE_PATCH, PAY_TIRE_PATCH } from '../../constants/graph/mutation'
import { CREATE_TIRE_PATCH_SHOP } from '../../constants/graphql/mutation'
import history from '../../history'
import { theme } from '../../styles/_variables'
import { status, statusText } from '../../pages/tire-patch-page/constants'
import { getAccessToken, getURL } from '../../utils/local-data-service'
import {
  MethodButton, EachInput, DatePicker as DP, TaxSelect,
} from './styled'
import { P } from '../../pages/tire-patch-page/styled'
import PERMISSION from '../../constants/permissions'

const { color } = theme

export const Wrapper = props => (
  <Div
    display='block'
    width='100%'
    flexDirection='row'
    padding={props.padding || '40px 0'}
    justifyContent={props.center && 'center'}
    alignItems='flex-end'
    style={{ borderBottom: `1px solid ${color.paleGrey}`, overflow: props.overflow && 'auto' }}
  >
    {props.children}
  </Div>
)

export const CellText = props => (
  <P font='sarabun' padding='3px' {...props}>{props.children}</P>
)

export const HeaderLabel = props => (
  <SmallText bold color={color.coolGrey} font='sarabun' style={{ fontWeight: 700 }}>{props.children}</SmallText>
)

export const InputWithPlaceHolder = ({ handleChange, value }) => (
  <input placeholder='ค้นหา' onChange={(e) => {
    handleChange(e.target.value)
  }} value={value} />
)

const menu = props => (
  <Div>
    <Menu>
      <Menu.Item key='view' disabled={!_.includes(window.perms, PERMISSION.VIEW_TIRE_PATCH)}>
        <Link target="_blank" to={`/tire-patch/view/${props.original.id}`}>
          ดูรายละเอียด
        </Link>
      </Menu.Item>
      <Menu.Item key='edit' disabled={!_.includes(window.perms, PERMISSION.UPDATE_TIRE_PATCH) || !(props.original.status === 'WAITING')}>
        <Link target="_blank" to={`/tire-patch/edit/${props.original.id}`}>
          แก้ไข
        </Link>
      </Menu.Item>
    </Menu>
  </Div>
)

export const ActionSelector = ({ props }) => (
  <Dropdown overlay={menu(props)} trigger='click'>
    <Button>
      ดูรายละเอียด <Icon type="down" />
    </Button>
  </Dropdown>
)

export const DropdownSelector = ({
  data, handleChange, brand,
}) => {
  const width = brand ? '130px' : '100px'
  return (
    <AntdSelect
      defaultValue='ทั้งหมด'
      dropdown
      maxHeight='none'
      style={{ width }}
      onChange={e => (e === 'ALL' ? handleChange('') : handleChange(e))}
    >
      {
        data.map(v => <AntdSelect.Option key={v.value} value={v.value}>{v.text}</AntdSelect.Option>)
      }
    </AntdSelect>
  )
}

export const AddTirePatchStoreModal = ({ addTirePatchStoreModal, setAddTirePatchStoreModal }) => {
  const [name, setName] = useState()
  const [phoneNumber, setPhoneNumber] = useState()
  const [address, setAddress] = useState()
  const [doAction, { loading: addTirePatchStoreLoading }] = useMutation(CREATE_TIRE_PATCH_SHOP, { refetchQueries: ['TirePatchStoreList'] })
  return (
      <Modal
        title="เพิ่มร้านปะยาง"
        visible={addTirePatchStoreModal}
        destroyOnClose={true}
        onCancel={() => {
          setAddTirePatchStoreModal(false)
          setName()
          setPhoneNumber()
          setAddress()
        }}
        onOk={() => {
          doAction({
            variables: {
              name,
              phoneNumber,
              address,
            },
          }).then(({ data }) => {
            const resp = data.CreateTirePatchStore
            if (resp.success) {
              message.success(resp.message)
            } else message.error(resp.message)
          })
          setAddTirePatchStoreModal(false)
          setName()
          setPhoneNumber()
          setAddress()
        }}
        okButtonProps={{
          loading: addTirePatchStoreLoading,
          disabled: addTirePatchStoreLoading || _.isEmpty(name) || _.isEmpty(phoneNumber),
        }}
        cancelButtonProps={{
          disabled: addTirePatchStoreLoading,
        }}
      >
        <Div display='flex' flexDirection='row' alignItems='center' margin='0 0 16px'>
          <InputWithLabel
            title={{ text: 'ชื่อร้านปะยาง *' }}
            margin='0 16px 0 0'
            input={{ onChange: e => setName(e.target.value), value: name }} />
        </Div>
        <Div display='flex' flexDirection='row' alignItems='center' margin='0 0 16px'>
          <InputWithLabel
            title={{ text: 'เบอร์โทรศัพท์ *' }}
            margin='0 16px 0 0'
            input={{ onChange: e => setPhoneNumber(e.target.value), value: phoneNumber }} />
        </Div>
        <Div display='flex' flexDirection='row' alignItems='center' margin='0 0 16px'>
          <InputWithLabel
            title={{ text: 'ที่อยู่' }}
            margin='0 16px 0 0'
            input={{ onChange: e => setAddress(e.target.value), value: address }} />
        </Div>
      </Modal>
  )
}

const ApproveModal = ({
  id, setApproveModal, approveModal, refetch, approveDoAction, approveLoading, mutationVariables, setMutationVariables,
}) => {
  const [isApprove, setIsApprove] = useState(true)
  const [rejectReason, setRejectReason] = useState('')
  return (
    <Modal
      title="อนุมัติการปะยาง"
      visible={approveModal}
      destroyOnClose={true}
      onCancel={() => {
        setApproveModal(false)
        setIsApprove(true)
        setRejectReason('')
      }}
      onOk={() => {
        approveDoAction({
          variables: {
            id,
            isApprove,
            rejectReason,
          },
        }).then(({ data }) => {
          const KEY = 'ApproveTirePatchLog'
          if (data[KEY].success) {
            message.success(data[KEY].message)
            setMutationVariables({
              ...mutationVariables,
              status: isApprove ? 'APPROVED' : 'CANCEL',
            })
            refetch()
          } else message.error(data[KEY].message)
        })
        setApproveModal(false)
        setIsApprove(true)
        setRejectReason('')
      }}
      okButtonProps={{
        loading: approveLoading,
        disabled: !isApprove && _.isEmpty(rejectReason),
      }}
      cancelButtonProps={{
        disabled: approveLoading,
      }}
    >
      <Div display='flex' flexDirection='row' alignItems='center' justifyContent='space-evenly' margin='0 0 16px'>
        <Radio.Group value={isApprove} size="large" onChange={(e) => {
          setIsApprove(e.target.value)
        }}>
          <Radio.Button value={true}>อนุมัติ</Radio.Button>
          <Radio.Button value={false}>ไม่อนุมัติ</Radio.Button>
        </Radio.Group>
      </Div>
      { !isApprove
        && <InputWithLabel
        title={{ text: 'เหตุผล *' }}
        margin='0 16px 0 0'
        input={{ onChange: e => setRejectReason(e.target.value), value: rejectReason }} />
      }
    </Modal>
  )
}

const PaidModal = ({
  id, setPaidModal, paidModal, refetch, paidDoAction, paidLoading, totalPaid, mutationVariables, setMutationVariables,
}) => {
  const [paidType, setPaidType] = useState('CASH')
  const [paidDate, setPaidDate] = useState()
  const [files, setFiles] = useState([])
  return (
    <Modal
      title="บันทึกการชำระเงิน"
      visible={paidModal}
      destroyOnClose={true}
      onCancel={() => {
        setPaidModal(false)
        setPaidType('CASH')
        setPaidDate()
        setFiles([])
      }}
      onOk={() => {
        paidDoAction({
          variables: {
            id,
            paidType,
            paidDate,
            files,
            totalPaid,
          },
        }).then(({ data }) => {
          const KEY = 'PayTirePatchLog'
          if (data[KEY].success) {
            message.success(data[KEY].message)
            refetch()
            setMutationVariables({
              ...mutationVariables,
              status: 'PAID',
            })
          } else message.error(data[KEY].message)
        })
        setPaidModal(false)
        setPaidType('CASH')
        setPaidDate()
        setFiles([])
      }}
      okButtonProps={{
        loading: paidLoading,
        disabled: _.isEmpty(paidDate) || (paidType === 'TRANSFER' && files.length === 0) || _.isNull(totalPaid) || _.isNaN(totalPaid),
      }}
      cancelButtonProps={{
        disabled: paidLoading,
      }}
    >
      <Div display='flex' flexDirection='row' justifyContent='space-around' margin='0 0 24px'>
        <MethodButton
          onClick={() => {
            setPaidType('CASH')
          }}
          bg={paidType === 'CASH'}
        >เงินสด</MethodButton>
        <MethodButton
          onClick={() => {
            setPaidType('TRANSFER')
          }}
            bg={paidType === 'TRANSFER'}
        >โอนเงิน</MethodButton>
      </Div>
      <EachInput>
        {/* paidDate */}
        <P>วันที่จ่าย *</P>
        <DP format='DD/MM/YYYY'
          onChange={e => setPaidDate(e)} />
      </EachInput>
      <EachInput>
        {/* bankFees */}
        <P>ราคา *</P>
        <Input width='100%'
          value={totalPaid}
          disabled={true}
          type='number'
          step={0.1}
          min={0}
        />
      </EachInput>
      <Div display='flex' justifyContent='center' margin='12px 0 0'>
        <Upload
          listType="picture-card"
          customRequest={() => null}
          processData={false}
          beforeUpload={() => false}
          multiple={true}
          onChange={e => setFiles(e.fileList.map(v => (_.isUndefined(v.originFileObj) ? { url: v.url } : v.originFileObj)))}
        >
          <div>
            <Icon type="plus" />
            <div className="ant-upload-text">อัพโหลด</div>
          </div>
        </Upload>
      </Div>
    </Modal>
  )
}

export const ActionBar = ({
  loading, isAddMode, isViewMode, doAction, mutationVariables, props, disabled, refetch, setMutationVariables,
}) => {
  const [approveModal, setApproveModal] = useState(false)
  const [paidModal, setPaidModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [approveDoAction, { loading: approveLoading }] = useMutation(APPROVE_TIRE_PATCH)
  const [paidDoAction, { loading: paidLoading }] = useMutation(PAY_TIRE_PATCH)
  return (
    <Div
      position='fixed'
      height='72px'
      bottom='0'
      left='0'
      right='0'
      style={{ background: `${color.primaryColor}33` }}
      display='flex'
      justifyContent='flex-end'
      alignItems='center'
      padding='0 32px 0 0'
    >
      <KonsysButton
        text='พิมพ์บิลปะยาง'
        icon='fas fa-print'
        loading={isLoading}
        // disabled={!window.role === 'SuperAdmin' || isAddMode || !(mutationVariables.status === 'WAITING')}
        disabled={isAddMode}
        onClick={() => {
          setIsLoading(true)
          window.open(
            `${getURL().FILE_SERVER}/render/pdf/tirePatchLogsInfo?id=${props.match.params.id}&t=${getAccessToken()}`,
            '_blank',
            'toolbar=false,scrollbars=yes,resizable=false',
          )
          setIsLoading(false)
        }}
        margin='0 8px'
      />
      <KonsysButton
        text='บันทึกการชำระเงิน'
        icon='fas fa-save'
        loading={approveLoading}
        // disabled={!window.role === 'SuperAdmin' || isAddMode || !(mutationVariables.status === 'WAITING')}
        disabled={isAddMode || !(mutationVariables.status === 'APPROVED')}
        onClick={() => {
          setPaidModal(true)
        }}
        margin='0 8px'
      />
      <KonsysButton
        text='อนุมัติการปะยาง'
        icon='fas fa-check'
        loading={approveLoading}
        disabled={!window.role === 'SuperAdmin' || isAddMode || !(mutationVariables.status === 'WAITING')}
        onClick={() => {
          setApproveModal(true)
        }}
        margin='0 8px'
      />
      <KonsysButton
        loading={loading}
        disabled={loading || (isViewMode && !_.includes(window.perms, PERMISSION.UPDATE_TIRE_PATCH)) || disabled}
        text={isAddMode ? 'สร้างใหม่' : isViewMode ? 'แก้ไข' : 'บันทึก'}
        icon={isAddMode ? 'fas fa-plus' : isViewMode ? 'fas fa-edit' : 'fas fa-save'}
        inverse
        onClick={() => {
          if (isViewMode) history.push(`/tire-patch/edit/${props.match.params.id}`)
          else {
            doAction({
              variables: isAddMode ? { ...mutationVariables } : { id: parseInt(props.match.params.id, 10), ...mutationVariables },
              refetchQueries: [{
                query: TIRE_PATCH_LIST,
                variables: {
                  limit: 5, offset: 0, orderField: 'updatedAt', orderBy: 'DESC',
                },
              }],
            }).then(({ data }) => {
              const resp = isAddMode ? data.CreateTirePatchLog : data.UpdateTirePatchLog // *
              if (resp.success) {
                message.success(resp.message)
                if (isAddMode) history.push('/tire-patch')
                // else {
                //   refetch()
                //   history.push(`/mechanic/view/${props.match.params.id}`)
                // }
              } else message.error(resp.message)
            })
          }
        }}
      />
      <ApproveModal
        id={!isAddMode ? parseInt(props.match.params.id, 10) : null}
        approveModal={approveModal}
        setApproveModal={setApproveModal}
        approveDoAction={approveDoAction}
        refetch={refetch}
        approveLoading={approveLoading}
        mutationVariables={mutationVariables}
        setMutationVariables={setMutationVariables}
      />
      <PaidModal
        id={!isAddMode ? parseInt(props.match.params.id, 10) : null}
        totalPaid={!isAddMode ? mutationVariables ? mutationVariables.price : null : null}
        paidModal={paidModal}
        setPaidModal={setPaidModal}
        paidDoAction={paidDoAction}
        refetch={refetch}
        paidLoading={paidLoading}
        mutationVariables={mutationVariables}
        setMutationVariables={setMutationVariables}
      />
    </Div>
  )
}
